// extracted by mini-css-extract-plugin
module.exports = {"menuButton":"_30FV1c","menuItems":"_3Gha4r","menuItem":"_2QCw-w","avatar":"w5v232"};